import AddElement from './addElement.vue';
import Vue from 'vue';
import KeepScrollPos from './../../../../utilities/keepScrollPos/keepScrollPos';

export const vmAddElement = new Vue({
  components: { AddElement },
  template: '<AddElement :value-props="value" />',
  data () {
    return {
      value: [],
      keepPos: new KeepScrollPos() // スクロール位置保持のインスタンス生成
    };
  },
  beforeUpdate: function () {
    this.keepPos.savePosition();
  },
  updated: function () {
    this.keepPos.applyPosition();
  }
});
